import { Formik } from 'formik';
import { validationSchemaTicketCategory, initValuesTicketCategory } from './createTicketCategoryValidation';
import Form from "./TicketCategoryForm";
import { useAxios } from "../../../../context/AxiosHookContext";

const FormCreateTicketCategory = ({ onClose,valuesToEdit , getValues})=>{

    const getInitialValues = () => {
        return (valuesToEdit && Object.keys(valuesToEdit).length) > 0 ? valuesToEdit : initValuesTicketCategory
    }

    const axios = useAxios();

    const handleSubmit = async (ticketCategory) => {
        try {

            if(ticketCategory.type === "support_type"){
                delete ticketCategory.father
            }

            if (ticketCategory._id) {
                const { _id, ...body } = ticketCategory;
                await axios.put(`/tickets/category/${_id}`, body)
            } else {
                await axios.post("/tickets/category", ticketCategory);
            }

        } catch (error) {
            console.log(error)
        } finally {
          getValues();
        }
    }

return (
    <Formik
    validationSchema={validationSchemaTicketCategory}
    initialValues={getInitialValues()}
    onSubmit={handleSubmit}
    validateOnChange
    >
        <Form onClose={()=>{getValues();onClose()}}/> 
    </Formik>
)
}

export default FormCreateTicketCategory